import { dayjs } from '../../../../utils/dayjs-utils';
import { formatNumber } from '../../../../utils/global';
import likeIcon from '../../../../images/discovery/demographics/like.svg';
import commentIcon from '../../../../images/discovery/demographics/comment.svg';

export default function PostCard({ username, postedOn, link, image, description, likesCount, commentsCount }) {
  return (
    <div className="post-card" onClick={() => window.open(link, '_blank')}>
      <div className="image-container">
        <img
          src={image}
          alt={username}
          onError={(e) => {
            e.currentTarget.src = 'https://letusstudy.in/clientside/images/no-image.png';
          }}
        />
      </div>
      <div className="post-content">
        <p className="date-text">{dayjs(new Date(postedOn)).format('MMMM	MM, YYYY')}</p>
        <p className="description-text">
          {description?.length > 120 ? description?.slice(0, 120) + '...' : description}
        </p>
        <div className="post-bottom-container">
          <div>
            <img src={likeIcon} alt="" />
            <p>{isNaN(likesCount) ? 'N/A' : formatNumber(likesCount)}</p>
          </div>
          <div>
            <img src={commentIcon} alt="" />
            <p>{isNaN(commentsCount) ? 'N/A' : formatNumber(commentsCount)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
